// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"9ddb163e","426":"4ee7fb26","479":"cd68d782","488":"abd388a3","525":"694176a5","546":"373a539e","628":"2828167f","677":"6acc33dc","721":"9327f0cd","778":"86d8335d","852":"6ea44e2a","959":"2cf6f4f4","973":"450880a2"}[chunkId] + ".chunk.js";
};